import { render, staticRenderFns } from "./InvestorMatches.vue?vue&type=template&id=d207e4a0"
import script from "./InvestorMatches.vue?vue&type=script&lang=js"
export * from "./InvestorMatches.vue?vue&type=script&lang=js"
import style0 from "./InvestorMatches.vue?vue&type=style&index=0&id=d207e4a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports